"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscordRelayMessageMessageToJSON = exports.DiscordRelayMessageMessageFromJSONTyped = exports.DiscordRelayMessageMessageFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function DiscordRelayMessageMessageFromJSON(json) {
    return DiscordRelayMessageMessageFromJSONTyped(json, false);
}
exports.DiscordRelayMessageMessageFromJSON = DiscordRelayMessageMessageFromJSON;
function DiscordRelayMessageMessageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'channelId': json['channelId'],
        'guildId': json['guildId'],
        'content': json['content'],
        'timestamp': (new Date(json['timestamp'])),
        'author': (0, _1.DiscordRelayMessageMessageAuthorFromJSON)(json['author']),
        'attachments': !(0, runtime_1.exists)(json, 'attachments') ? undefined : json['attachments'],
        'embeds': !(0, runtime_1.exists)(json, 'embeds') ? undefined : json['embeds'],
        'editedTimestamp': !(0, runtime_1.exists)(json, 'editedTimestamp') ? undefined : (json['editedTimestamp'] === null ? null : new Date(json['editedTimestamp'])),
    };
}
exports.DiscordRelayMessageMessageFromJSONTyped = DiscordRelayMessageMessageFromJSONTyped;
function DiscordRelayMessageMessageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'channelId': value.channelId,
        'guildId': value.guildId,
        'content': value.content,
        'timestamp': (value.timestamp.toISOString()),
        'author': (0, _1.DiscordRelayMessageMessageAuthorToJSON)(value.author),
        'attachments': value.attachments,
        'embeds': value.embeds,
        'editedTimestamp': value.editedTimestamp === undefined ? undefined : (value.editedTimestamp === null ? null : value.editedTimestamp.toISOString()),
    };
}
exports.DiscordRelayMessageMessageToJSON = DiscordRelayMessageMessageToJSON;
